import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  chooseFile = () => {
    this.element.querySelector("input[type=file]").click();
  }
}
